import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function ShirdiToGoaCabService() {



    const cardData = {





keyword: "Shirdi to Goa Cab Service",

headingDescription: "Sai Shirdi Cab provides comfortable and reliable Shirdi to Goa Cab Service for devotees, families, couples, tourists, and groups planning a long-distance journey from Shirdi to Goa. Customers can book private chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, and other suitable vehicles for one-way travel, round trips, family vacations, weekend trips, multi-day holidays, and customized Goa travel plans. The private cab service offers direct door-to-door transportation, allowing passengers to travel comfortably without changing vehicles during the journey. With experienced drivers, clean and well-maintained vehicles, comfortable seating, sufficient luggage space, flexible pickup timings, and convenient hotel or resort drops, Sai Shirdi Cab makes the long road journey easier to organize. Travelers can select a vehicle according to their group size and luggage requirements and can also customize the itinerary with suitable breaks or sightseeing stops along the route.",

topPlaces: [
{
title: "Goa",
description: "Goa is the main destination for this long-distance cab journey and is popular for beaches, coastal scenery, heritage attractions, churches, markets, and leisure activities. Travelers from Shirdi can book a private cab directly to their hotel, resort, beach area, or preferred location. One-way and round-trip services are suitable for families, couples, and groups."
},
{
title: "Panaji",
description: "Panaji is the capital city of Goa and offers heritage architecture, churches, riverfront views, markets, and access to several popular attractions. Travelers arriving from Shirdi can arrange a private cab for a direct hotel drop or sightseeing tour. The itinerary can be customized according to the duration of the Goa holiday."
},
{
title: "Calangute",
description: "Calangute is a popular North Goa beach destination known for its coastline, restaurants, shopping, and lively holiday atmosphere. Travelers can book a private cab from Shirdi directly to their accommodation in Calangute. Families and groups can also use the service to explore nearby North Goa attractions."
},
{
title: "Baga",
description: "Baga is a well-known North Goa destination popular for its beach, restaurants, entertainment options, and vibrant atmosphere. Travelers from Shirdi can arrange a private cab for direct transportation to hotels and resorts. Flexible travel arrangements allow customers to combine Baga with nearby sightseeing locations."
},
{
title: "Candolim",
description: "Candolim is a popular coastal destination in North Goa offering beaches, resorts, restaurants, and a relaxed holiday environment. Travelers can book a private cab from Shirdi for comfortable door-to-door transportation. It is a convenient option for families and couples looking for a peaceful beach vacation."
},
{
title: "Margao",
description: "Margao is an important commercial and cultural city in South Goa and provides convenient access to several southern beaches and attractions. Travelers from Shirdi can arrange a private cab directly to hotels, residences, or other destinations. Spacious vehicles are suitable for families and groups traveling with luggage."
},
{
title: "Vasco da Gama",
description: "Vasco da Gama is an important city in Goa and is useful for travelers visiting for business, family requirements, or airport connections. Customers can book a private cab from Shirdi for a direct long-distance journey. Flexible pickup and destination drop options make the service convenient for different travel schedules."
},
{
title: "Old Goa",
description: "Old Goa is a major heritage destination known for historic churches, monuments, and Portuguese-era architecture. Travelers can include Old Goa in their Goa sightseeing itinerary after reaching the state. A private cab provides convenient transportation between hotels and heritage attractions for families and groups."
},
{
title: "Dudhsagar",
description: "Dudhsagar is one of the most famous natural attractions associated with Goa and is known for its impressive waterfall and forest surroundings. Travelers planning a sightseeing-focused holiday can include Dudhsagar in their itinerary. Private cab service offers convenient transportation to suitable access points and nearby destinations."
},
{
title: "Ponda",
description: "Ponda is an inland Goa destination known for temples, greenery, and cultural attractions. Travelers who want to explore more than the beaches can include Ponda in a customized Goa itinerary. Private transportation provides flexibility for families and groups planning multiple sightseeing stops."
},
{
title: "Vagator",
description: "Vagator is a scenic North Goa destination known for its beaches, rocky coastline, viewpoints, and relaxed holiday atmosphere. Travelers from Shirdi can arrange a private cab directly to their hotel or resort. The service also allows customers to combine Vagator with nearby Anjuna and other coastal attractions."
},
{
title: "Palolem",
description: "Palolem is a popular South Goa beach destination known for its scenic coastline and peaceful surroundings. Travelers looking for a relaxed beach vacation can book a private cab from Shirdi for direct transportation. Comfortable vehicles with sufficient luggage space are suitable for families and groups planning longer stays."
}
],










"services": [
{
"name": "Shirdi to Goa Cab Service",
"description": "Shirdi to Goa Cab Service provides convenient private transportation for passengers traveling from Shirdi to Goa. Travelers can choose a suitable vehicle based on passenger count, luggage requirements, pickup location, travel schedule, and one-way or return journey preferences."
},
{
"name": "Shirdi to Goa Cab",
"description": "Shirdi to Goa Cab offers a comfortable point-to-point travel option for individuals, families, and groups heading toward Goa. Cab arrangements can be planned according to the preferred vehicle category, pickup timing, passenger requirements, and destination."
},
{
"name": "Shirdi to Goa Taxi",
"description": "Shirdi to Goa Taxi provides private transportation for travelers planning an intercity journey from Shirdi to Goa. Customers can select a suitable taxi according to seating capacity, luggage space, travel date, pickup location, and preferred trip type."
},
{
"name": "Shirdi to Goa Taxi Service",
"description": "Shirdi to Goa Taxi Service is suitable for passengers looking for reliable private transportation between Shirdi and Goa. The service can be arranged for family travel, personal trips, vacations, and other journeys with suitable vehicle options."
},
{
"name": "Shirdi to Goa Cab Service",
"description": "Shirdi to Goa Cab Service provides direct intercity transportation for passengers traveling toward Goa. Travelers can plan their journey with an appropriate vehicle based on passenger count, luggage, pickup point, travel timing, and one-way or round-trip requirements."
},
{
"name": "Shirdi to Goa Cab Booking",
"description": "Shirdi to Goa Cab Booking allows travelers to reserve private transportation in advance for their journey from Shirdi to Goa. Customers can provide travel dates, pickup details, passenger count, luggage requirements, vehicle preference, and trip type."
},
{
"name": "Shirdi to Goa Taxi Booking",
"description": "Shirdi to Goa Taxi Booking provides a convenient way to arrange private taxi transportation for a scheduled journey to Goa. The booking can be organized according to pickup location, travel time, passenger requirements, vehicle category, and destination."
},
{
"name": "Shirdi to Goa Taxi Fare",
"description": "Shirdi to Goa Taxi Fare may vary depending on the selected vehicle, journey type, route, passenger count, and additional travel requirements. Travelers can request a suitable fare option for one-way, round-trip, or customized transportation."
},
{
"name": "Shirdi to Goa Cab Fare",
"description": "Shirdi to Goa Cab Fare depends on factors such as vehicle category, trip type, pickup location, passenger capacity, and travel itinerary. Customers can select a suitable cab according to their comfort preferences, budget, and journey requirements."
},
{
"name": "Shirdi to Goa One Way Taxi",
"description": "Shirdi to Goa One Way Taxi provides direct private transportation for passengers who only require travel toward Goa without a return booking. The taxi can be arranged from the selected pickup point in Shirdi to the preferred destination in Goa."
},
{
"name": "Shirdi to Goa One Way Cab",
"description": "Shirdi to Goa One Way Cab is a practical option for travelers needing direct transportation to Goa. Cab arrangements can be selected according to passenger count, luggage requirements, pickup timing, vehicle preference, and destination."
},
{
"name": "Shirdi to Goa Round Trip Taxi",
"description": "Shirdi to Goa Round Trip Taxi is suitable for travelers planning to visit Goa and return to Shirdi. The journey can be scheduled according to travel dates, stay duration, passenger count, vehicle category, waiting requirements, and preferred return itinerary."
},
{
"name": "Shirdi to Goa Ertiga Cab",
"description": "Shirdi to Goa Ertiga Cab offers spacious private transportation for families and small groups traveling between Shirdi and Goa. The Ertiga provides comfortable seating and luggage space and can be arranged for one-way, round-trip, or customized travel plans."
},
{
"name": "Shirdi to Goa Innova Cab",
"description": "Shirdi to Goa Innova Cab provides a spacious travel option for families and groups requiring additional seating and luggage capacity. The Innova can be arranged for direct journeys, vacation trips, return travel, and customized transportation requirements."
},
{
"name": "Shirdi to Goa Innova Crysta Cab",
"description": "Shirdi to Goa Innova Crysta Cab is a comfortable option for travelers who prefer a premium and spacious vehicle for the long-distance journey. The vehicle is suitable for families and groups and can be arranged for one-way or round-trip travel."
},
{
"name": "Shirdi to Goa Sedan Cab",
"description": "Shirdi to Goa Sedan Cab provides a practical private travel option for individuals and smaller families. Sedan vehicles can be arranged according to passenger count, luggage requirements, travel date, pickup location, and one-way or return journey needs."
},
{
"name": "Shirdi to Goa Tempo Traveller on Rent",
"description": "Shirdi to Goa Tempo Traveller on Rent is designed for larger families and groups requiring additional seating capacity for their Goa journey. The vehicle can be arranged with convenient pickup, luggage space, and an itinerary planned according to group travel requirements."
},
{
"name": "Goa to Shirdi Taxi",
"description": "Goa to Shirdi Taxi provides private transportation for passengers traveling from Goa toward Shirdi. Travelers can select a suitable vehicle according to passenger capacity, luggage requirements, pickup location, travel timing, and one-way or return journey preferences."
},
{
"name": "Goa to Shirdi Cab",
"description": "Goa to Shirdi Cab offers convenient point-to-point transportation for travelers returning from Goa to Shirdi. The cab can be arranged according to the preferred pickup location, vehicle category, passenger count, luggage, travel date, and destination."
},
{
"name": "Affordable Shirdi to Goa Taxi Service",
"description": "Affordable Shirdi to Goa Taxi Service provides a practical transportation option for travelers looking for a suitable private cab within their budget. Customers can choose an appropriate vehicle based on passenger capacity, luggage, trip type, pickup location, and travel requirements."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides private cab and taxi transportation for travelers between Shirdi, Goa, and other destinations. Suitable sedan, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other vehicle options can be arranged for local, pilgrimage, airport, and outstation travel requirements."
}
],
"tableData": [
["Shirdi to Goa Cab Service", "Shirdi to Goa Cab"],
["Shirdi to Goa Taxi", "Shirdi to Goa Taxi Service"],
["Shirdi to Goa Cab Service", "Shirdi to Goa Cab Booking"],
["Shirdi to Goa Taxi Booking", "Shirdi to Goa Taxi Fare"],
["Shirdi to Goa Cab Fare", "Shirdi to Goa One Way Taxi"],
["Shirdi to Goa One Way Cab", "Shirdi to Goa Round Trip Taxi"],
["Shirdi to Goa Ertiga Cab", "Shirdi to Goa Innova Cab"],
["Shirdi to Goa Innova Crysta Cab", "Shirdi to Goa Sedan Cab"],
["Shirdi to Goa Tempo Traveller on Rent", "Goa to Shirdi Taxi"],
["Goa to Shirdi Cab", "Affordable Shirdi to Goa Taxi Service"],
["Sai Shirdi Cabs", "Shirdi to Goa Cab Service"]
]
,















    whychoose: [
        { 
            WhyChooseheading: "Relaxed Shirdi to Goa Cab Service for Long-Distance Travel", 
            WhyChoosedescription: "Sai Shirdi Cabs provides private cab services from Shirdi to Goa for families, couples, tourists, groups, and travellers planning an intercity holiday. A dedicated vehicle offers a convenient way to travel between Shirdi and Goa while allowing you to manage your departure, luggage, and journey preferences." 
        }, 
        { 
            WhyChooseheading: "Pickup from Your Location in Shirdi", 
            WhyChoosedescription: "Start your Goa journey with pickup from your hotel, residence, temple area, railway station surroundings, or another convenient location in Shirdi. Departure timing can be coordinated according to your accommodation checkout and planned travel schedule." 
        }, 
        { 
            WhyChooseheading: "Direct Private Travel to Goa", 
            WhyChoosedescription: "Travel from Shirdi towards Goa in a dedicated cab without changing vehicles during the journey. Private transportation can be especially useful for families and groups travelling with luggage who prefer a more organized long-distance trip." 
        }, 
        { 
            WhyChooseheading: "Suitable for Family Holidays & Group Trips", 
            WhyChoosedescription: "Families, friends, couples, and small travel groups can select a vehicle according to their passenger count, luggage, and comfort requirements. Travelling together makes it easier to coordinate the journey and reach Goa as a group." 
        }, 
        { 
            WhyChooseheading: "Flexible One-Way Cab to Goa", 
            WhyChoosedescription: "Travellers who only need transportation from Shirdi to Goa can choose a one-way cab arrangement. This is useful when return travel has already been planned separately or when Goa is the next destination on a longer itinerary." 
        }, 
        { 
            WhyChooseheading: "Round-Trip Option for Goa Holidays", 
            WhyChoosedescription: "Passengers planning to return to Shirdi can discuss a round-trip cab arrangement with a suitable return schedule. The journey can be organized around your Goa holiday, sightseeing plans, hotel stay, and preferred travel dates." 
        }, 
        { 
            WhyChooseheading: "Comfortable Vehicles for a Long Journey", 
            WhyChoosedescription: "Select from suitable vehicle categories such as sedan cars, Ertiga, Innova, Innova Crysta, SUVs, or larger vehicles depending on the number of passengers and luggage. Vehicle selection can be discussed according to your overall travel needs." 
        }, 
        { 
            WhyChooseheading: "Book Shirdi to Goa Cab Service with Sai Shirdi Cabs", 
            WhyChoosedescription: "Share your Shirdi pickup point, Goa destination, travel date, passenger count, luggage details, preferred vehicle, and one-way or return requirement with Sai Shirdi Cabs to arrange a suitable private cab for your journey." 
        } 
    ] 

}; 

const faqData = [ 
    { 
        question: "Can I book a cab from Shirdi to Goa?", 
        answer: "Yes, Sai Shirdi Cabs provides private cab services from Shirdi to Goa for families, couples, tourists, groups, and other travellers." 
    }, 
    { 
        question: "Can I get pickup from my hotel in Shirdi for Goa?", 
        answer: "Yes, pickup can be arranged from your Shirdi hotel, residence, temple area, railway station surroundings, or another convenient location." 
    }, 
    { 
        question: "Is Shirdi to Goa Cab Service suitable for family holidays?", 
        answer: "Yes, private cab travel is suitable for families and groups who want to travel together with their luggage in a dedicated vehicle." 
    }, 
    { 
        question: "Do you provide one-way Shirdi to Goa Cab service?", 
        answer: "Yes, one-way cab service is available for passengers who require direct transportation from Shirdi to Goa without needing the same vehicle for the return journey." 
    }, 
    { 
        question: "Can I book a round-trip taxi from Shirdi to Goa?", 
        answer: "Yes, round-trip cab arrangements can be discussed for travellers who want transportation back after completing their Goa holiday or planned stay." 
    }, 
    { 
        question: "Which vehicles are available for Shirdi to Goa travel?", 
        answer: "Vehicle options may include sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and larger vehicles depending on passenger count, luggage, and travel requirements." 
    }, 
    { 
        question: "Can I carry luggage in the Shirdi to Goa taxi?", 
        answer: "Yes, passengers can carry luggage according to the available storage capacity of the selected vehicle. Additional or bulky baggage should be mentioned while booking." 
    }, 
    { 
        question: "Can couples book a private cab from Shirdi to Goa?", 
        answer: "Yes, couples can book a private cab for direct travel from Shirdi to Goa and select a suitable vehicle based on their luggage and comfort requirements." 
    }, 
    { 
        question: "Can I customize my Shirdi to Goa travel plan?", 
        answer: "Yes, passengers can discuss additional stops, sightseeing requirements, hotel pickups, destinations in Goa, and return arrangements while planning their private cab journey." 
    }, 
    { 
        question: "How can I book Shirdi to Goa Cab Service with Sai Shirdi Cabs?", 
        answer: "Share your Shirdi pickup location, Goa destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or return preference with Sai Shirdi Cabs to proceed with the cab booking." 
    } 
]; 

const testimonials = [ 
    { 
        id: 1, 
        name: "Mr. Akash More", 
        feedback: "After completing our Shirdi visit, we travelled to Goa with our family. The private cab was a convenient choice for the long journey because everyone could stay together and carry their holiday luggage comfortably.", 
        rating: 5 
    }, 
    { 
        id: 2, 
        name: "Mrs. Ritu Sawant", 
        feedback: "We booked a private taxi from Shirdi to Goa for a family holiday. Having direct transportation made our travel plan easier, and we did not have to worry about changing vehicles along the way.", 
        rating: 5 
    } 
];








    

    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shirdi to Goa Cab Service",
  "image": "https://www.saishirdicabs.com/assets/images/shirdi-to-goa-cab-service.webp",
  "description":
    "Book Shirdi to Goa Cab Service with Sai Shirdi Cabs for a safe, comfortable, and reliable long-distance journey from Shirdi to Goa. We provide one-way, round-trip, and outstation taxi services for families, tourists, devotees, couples, and groups. Choose from Sedan, Ertiga, Innova, Innova Crysta, and Tempo Traveller with professional drivers, comfortable vehicles, convenient pickup and drop facilities, flexible travel options, and affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/shirdi-to-goa-cab-service"
  }
};




    return (
        <div>

<Helmet>
  <title>Shirdi to Goa Cab Service | Shirdi to Goa Taxi | +91 7776814559</title>

  <meta
    name="description"
    content="Book Shirdi to Goa Cab Service with Sai Shirdi Cabs for affordable one-way, round-trip and outstation taxi services. Hire Sedan, Ertiga, Innova, Innova Crysta and Tempo Traveller from Shirdi to Goa with professional drivers, comfortable travel, easy booking and convenient pickup and drop."
  />

  <meta
    name="keywords"
    content="Shirdi to Goa Cab Service, Shirdi to Goa Cab, Shirdi to Goa Taxi, Shirdi to Goa taxi service, Shirdi to Goa cab service, Shirdi to Goa cab booking, Shirdi to Goa taxi booking, Shirdi to Goa taxi fare, Shirdi to Goa cab fare, Shirdi to Goa one way taxi, Shirdi to Goa one way cab, Shirdi to Goa round trip taxi, Shirdi to Goa round trip cab, Shirdi to Goa Online Cab Booking, Shirdi to Goa Online Taxi Booking, Shirdi Goa Cab Service, Shirdi Goa Cab, Shirdi Goa Taxi, Goa to Shirdi Cab, Goa to Shirdi Taxi, Goa to Shirdi Cab Service, Goa to Shirdi Taxi Service, Goa to Shirdi Cab Booking, Goa to Shirdi Taxi Booking, Goa to Shirdi One Way Cab, Goa to Shirdi One Way Taxi, Goa to Shirdi Round Trip Cab, Goa to Shirdi Round Trip Taxi, Affordable Shirdi to Goa Cab, Cheap Shirdi to Goa Taxi, Best Shirdi to Goa Cab Service, Reliable Shirdi to Goa Taxi Service, Shirdi to Goa Sedan Cab, Shirdi to Goa Swift Dzire Cab, Shirdi to Goa Ertiga Cab, Shirdi to Goa Innova Cab, Shirdi to Goa Innova Crysta Cab, Shirdi to Goa Tempo Traveller, Shirdi to Goa Tempo Traveller on Rent, Shirdi to Goa Car Rental, Shirdi to Goa Car Hire, Shirdi to Goa Private Cab, Shirdi to Goa Family Cab, Shirdi to Goa Group Taxi, Shirdi to Goa Tourist Cab, Shirdi to Goa Travel Service, Shirdi to Goa Outstation Cab, Shirdi to Goa Outstation Taxi, Shirdi to Goa Tour Taxi, Shirdi to Goa Vacation Cab, Shirdi Goa Taxi Booking, Goa Shirdi Cab Booking, Sai Shirdi Cabs"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/47.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default ShirdiToGoaCabService;